import { render, staticRenderFns } from "./AddPeledakan.vue?vue&type=template&id=0fb16469&lang=pug&"
import script from "./AddPeledakan.vue?vue&type=script&lang=js&"
export * from "./AddPeledakan.vue?vue&type=script&lang=js&"
import style0 from "./AddPeledakan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports